import { Stack, Text, Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

import { NATIVE_CHAIN_TICKER } from '@/constants/blockchain'

import TooltipTitle from '../TooltipTitle'

interface DataCardProps {
  title: string
  value: string
  description?: string[]
  tooltip?: string
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right'
}

const DataCard: React.FC<DataCardProps> = ({
  title,
  value,
  description = [''],
  tooltip = '',
  tooltipPosition = 'top',
}) => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)

  return (
    <Stack
      style={{
        // TODO: card width should not be hardcoded but follow equation based on page width, number of cards and padding
        width: '290px',
        height: isMobile ? 'auto' : '260px',
        backgroundColor: isMobile ? '' : theme.colors.background2[0],
        borderRadius: '12px',
        padding: isMobile ? '0' : '50px 37px 60px 50px',
        gap: '20px',
      }}
    >
      <TooltipTitle title={title} tooltip={tooltip} position={tooltipPosition} />
      <Title order={isMobile ? 4 : 3} style={{ color: theme.colors.paragraph[0] }}>
        {value} {NATIVE_CHAIN_TICKER}
      </Title>
      <Stack gap="0px">
        {description &&
          description.length > 0 &&
          description.map((desc, index) => (
            <Text
              key={description[index]}
              style={{
                fontSize: '14px',
                wordWrap: 'break-word',
              }}
            >
              {desc}
            </Text>
          ))}
      </Stack>
    </Stack>
  )
}

export default DataCard
